// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
  height: 50px;
  display: flex;
  padding: 20px 40px 20px 31px;
  font-size: 20px;
  border-bottom: 0.5px solid #acacac;
}
.header-container .header {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-between;
  align-items: center;
}
.header-container h1 {
  font-size: 16px;
  line-height: 19.5px;
  color: #003da5;
  font-weight: 500;
  margin: 0;
}
.header-container .user-date-time {
  display: flex;
  justify-content: space-around;
}
.header-container .user-date-time p {
  padding: 0 12px;
  color: #acacac;
  font-size: 14px;
  line-height: 17px;
}
.header-container .user-date-time p:first-child {
  padding-left: 0;
  border-right: 1px solid #acacac;
  padding-left: 0px;
  /* Optional: add padding to create some space between the text and the line */
}
.header-container .user-profile {
  display: flex;
  align-items: center;
}
.header-container .user-profile .notificaitons {
  width: 1.5rem;
  height: 1.8rem;
  cursor: pointer;
}
.header-container .user-profile .userProfile {
  width: 43.01px;
  height: 43px;
}
.header-container .user-profile p {
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 0 0 0 21.99px;
  font-size: 14px;
  font-weight: 500;
  color: #acacac;
  line-height: 17px;
  margin: 10px 0;
}
.header-container .user-profile p span {
  font-size: 12px;
}
.header-container .user-profile .notification-badge {
  position: relative;
  top: -0.7rem;
  right: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 1rem;
  background-color: #FF0000;
  color: white;
  font-size: 0.7rem;
  font-weight: 500;
  line-height: 1rem;
  text-align: center;
  border: 1px solid white;
}
.header-container .user-profile .userInfoSection {
  display: flex;
  align-items: center;
}
.header-container .user-profile .userInfoSection .userInfo {
  margin-right: 5px;
}
.header-container .user-profile .userInfoSection .dropdownBtn {
  background: transparent;
  border: none;
}
.header-container .header-title-container {
  display: flex;
  align-items: center;
  gap: 10px;
}
.header-container .expand-icon {
  transform: rotate(180deg);
  width: 24px;
  height: 24px;
  cursor: pointer;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Headers/index.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,4BAAA;EACA,eAAA;EACA,kCAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AAEE;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AAAJ;AAGE;EACE,aAAA;EACA,6BAAA;AADJ;AAGI;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AADN;AAGM;EACE,eAAA;EACA,+BAAA;EACA,iBAAA;EACA,6EAAA;AADR;AAME;EACE,aAAA;EACA,mBAAA;AAJJ;AAMI;EACE,aAAA;EACA,cAAA;EACA,eAAA;AAJN;AAOI;EACE,cAAA;EACA,YAAA;AALN;AAQI;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;AANN;AAQM;EACE,eAAA;AANR;AAUI;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AARN;AAWI;EACE,aAAA;EACA,mBAAA;AATN;AAWM;EACE,iBAAA;AATR;AAYM;EACE,uBAAA;EACA,YAAA;AAVR;AAeE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAbJ;AAgBE;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAdJ","sourcesContent":[".header-container {\n  height: 50px;\n  display: flex;\n  padding: 20px 40px 20px 31px;\n  font-size: 20px;\n  border-bottom: 0.5px solid #acacac;\n\n  .header {\n    display: flex;\n    flex-direction: row;\n    flex-grow: 1;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  h1 {\n    font-size: 16px;\n    line-height: 19.5px;\n    color: #003da5;\n    font-weight: 500;\n    margin: 0;\n  }\n\n  .user-date-time {\n    display: flex;\n    justify-content: space-around;\n\n    p {\n      padding: 0 12px;\n      color: #acacac;\n      font-size: 14px;\n      line-height: 17px;\n\n      &:first-child {\n        padding-left: 0;\n        border-right: 1px solid #acacac;\n        padding-left: 0px;\n        /* Optional: add padding to create some space between the text and the line */\n      }\n    }\n  }\n\n  .user-profile {\n    display: flex;\n    align-items: center;\n\n    .notificaitons {\n      width: 1.5rem;\n      height: 1.8rem;\n      cursor: pointer;\n    }\n\n    .userProfile {\n      width: 43.01px;\n      height: 43px;\n    }\n\n    p {\n      display: flex;\n      flex-direction: column;\n      text-align: left;\n      padding: 0 0 0 21.99px;\n      font-size: 14px;\n      font-weight: 500;\n      color: #acacac;\n      line-height: 17px;\n      margin: 10px 0;\n\n      span {\n        font-size: 12px;\n      }\n    }\n\n    .notification-badge {\n      position: relative;\n      top: -0.7rem;\n      right: 0.8rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 1.4rem;\n      height: 1.4rem;\n      border-radius: 1rem;\n      background-color: #FF0000;\n      color: white;\n      font-size: 0.7rem;\n      font-weight: 500;\n      line-height: 1rem;\n      text-align: center;\n      border: 1px solid white;\n    }\n\n    .userInfoSection {\n      display: flex;\n      align-items: center;\n\n      .userInfo {\n        margin-right: 5px;\n      }\n\n      .dropdownBtn {\n        background: transparent;\n        border: none;\n      }\n    }\n  }\n\n  .header-title-container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .expand-icon {\n    transform: rotate(180deg);\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    flex-shrink: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
